
import React, { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';
import { Navbar } from '../src/components/Navbar';
import { Footer } from '../src/components/Footer';
import './globals.css';

export default function RootLayout({ children }: { children?: React.ReactNode }) {
  useEffect(() => {
    let lenis: Lenis | null = null;
    let rafId: number;

    try {
      lenis = new Lenis({
        duration: 1.2,
        easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: true,
        touchMultiplier: 2,
      } as unknown as ConstructorParameters<typeof Lenis>[0]);

      function raf(time: number) {
        if (lenis) {
          lenis.raf(time);
        }
        rafId = requestAnimationFrame(raf);
      }

      rafId = requestAnimationFrame(raf);
    } catch (error) {
      console.warn('Lenis smooth scrolling not available:', error);
    }

    return () => {
      if (lenis) {
        lenis.destroy();
      }
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    };
  }, []);

  return (
    <div className="w-full min-h-screen selection:bg-[#11BC97] selection:text-white relative overflow-x-hidden font-sans">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
